import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

/**
 * The markdown rendering itself (GFM tables, task lists, LaTeX math) with no
 * layout wrapper — so it can be a full-pane document (MarkdownViewer) or one
 * cell among many (NotebookViewer) without imposing its own scroller.
 */
export default function MarkdownContent(props: { markdown: string }) {
  return (
    <article className="prose prose-sm max-w-3xl">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[rehypeKatex]}
      >
        {props.markdown}
      </ReactMarkdown>
    </article>
  );
}
